import { useLocation } from 'react-router';

import { ProcessedUserSectionItem, SidebarMenuItemProps } from '../../../types';
import { useSidebarContext } from '../SidebarContext';
import { SidebarMenu } from '../SidebarMenu';

import { SidebarItem } from './SidebarItem';

export const SidebarUserSectionItem = ({
  item,
}: SidebarMenuItemProps<ProcessedUserSectionItem['type']>) => {
  const { isActive } = useSidebarContext();
  const { pathname } = useLocation();
  const { title, children } = item;
  const settingsLink = '/user_section';
  const isActiveItem = isActive(pathname, settingsLink);

  return (
    <>
      <SidebarMenu menuLabel={title} items={children} />
      <SidebarItem
        href={settingsLink}
        color="original.brand.primary"
        iconName="sliders_outline"
        aqaClass={`aqa_${title}`}
        title="Настроить блок"
        isActive={isActiveItem}
        showIcon
      />
    </>
  );
};
